/** Abas do painel do edital; a ativa fica na URL (`/editais/:fitId?aba=conversa`). */
export const ABAS_PAINEL = { dados: 'Dados', anexos: 'Anexos', conversa: 'Conversa', historico: 'Histórico' } as const;
export type AbaPainel = keyof typeof ABAS_PAINEL;

export const validarAbaPainel = (raw: Record<string, unknown>): { aba: AbaPainel } => ({
  aba: typeof raw.aba === 'string' && raw.aba in ABAS_PAINEL ? (raw.aba as AbaPainel) : 'dados',
});
